module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_cancer_right-cfc9a547c9f339bef619c3ccc3d78376.png";